<template>
  <div class="my-4">
    <v-row class="mx-0 py-0 px-0">
      <v-col cols="auto">
        <Avatar :user="comment.owner" size="50"/>
      </v-col>
      <v-col style="font-family: Montserrat">
        <div class="mt-0 d-flex flex-column flex-sm-row justify-sm-space-between">
          <h3>{{ getDisplayNameOrEmail(comment.owner) }}</h3>
          <div class="d-flex flex-row" v-if="isAuthenticated && comment.owner.uuid === user.uuid">
            <v-btn small text @click="setEditMode(commentIndex)" class="text-capitalize">Edit</v-btn>
            <v-btn small text @click="setDeleteMode(commentIndex)" class="text-capitalize"> Delete</v-btn>
          </div>
        </div>
        <p style="color: #B4B4B4; font-size: .9em;">{{createdAt}}</p>
        <p  v-if="commentIndex !== commentEditIndex" v-html="comment.body" style="color: #8A8A8A"/>
        <template v-else>
          <quill-editor
              ref="myQuillEditor"
              :disabled="updateCommentLoading"
              :options="editorOptions"
              :value="commentEditBody"
              @change="onEditorChange($event)"
          />
          <v-row class="my-2 ml-1 pl-0 d-flex flex-row align-center justify-start">
            <v-btn
                :disabled="updateCommentLoading || !commentEditBody"
                :loading="updateCommentLoading"
                color="primary"
                elevation="0"
                class="text-capitalize mr-2 ml-0"
                small
                @click="updateComment(commentEditBody)"
            >
              Save
            </v-btn>
            <v-btn
                color="red"
                class="text-capitalize"
                outlined
                small
                @click="cancelEdit()"
            >
              Cancel
            </v-btn>
          </v-row>
        </template>
        <div class="d-flex flex-row align-center mb-2" style="color: #B4B4B4; font-size: .9em">
          <v-btn text small class="text-capitalize px-0" disabled>Like</v-btn>
          <v-btn text small class="ml-4 text-capitalize" disabled>Reply</v-btn>
        </div>
      </v-col>
    </v-row>
    <v-divider v-if="showBorder" style="border-color: #C2C2C2;"/>
  </div>
</template>

<script>
import Avatar from "@/components/Avatar";
import {constructDate} from "@/utilz/date";
import {getDisplayNameOrEmail} from "@/utilz/dispalyNameOrEmail";
import {mapGetters} from "vuex";
export default {
  name: "Comment",
  components: {Avatar},
  data() {
    return {
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ['link', 'image', 'video'],
              ["bold", "italic", "underline"],
              ["blockquote", "code-block"],
            ],
          },
        },
      },
    };
  },
  props: {
    comment: {
      required: true,
      type: Object,
      default: () => ({
        owner: {
          id: "",
          email: "",
          profile: {
            avatar: "",
          },
        },
      })
    },
    commentIndex: {
      required: true,
      type: Number,
      default() {
        return null;
      },
    },
    showBorder: {
      required: true,
      type: Boolean,
      default: true
    },
    commentEditBody: {
      type: String,
      default() {
        return "Guiomentor";
      },
    },
    commentEditIndex: {
      type: Number,
      default() {
        return null;
      },
    },
    updateCommentLoading: {
      type: Boolean,
      default() {
        return false;
      },
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/GET_IS_AUTHENTICATED",
      user: "auth/GET_USER",
    }),
    createdAt() {
      const date = new Date(this.comment.created);
      return constructDate(date.getDate(), date.getMonth(), date.getFullYear());
    },
  },
  methods: {
    getDisplayNameOrEmail(user) {
      return getDisplayNameOrEmail(user);
    },
    setEditMode(index) {
      this.$emit("setEditMode", index);
    },
    setDeleteMode(index) {
      this.$emit("setDeleteMode", index);
    },
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    updateComment() {
      this.$emit("updateComment");
    },
    onEditorChange(event) {
      this.$emit("onEditorChange", event.html);
    }
  }
}
</script>

<style  scoped>
::v-deep .v-btn__content {
  justify-content: start !important;
}
</style>
